/**
 * Rubina Irfan — Cart Page JS
 * AJAX qty/remove, in-place summary update, debounced note save.
 */

(function () {
  'use strict';

  var NOTE_DEBOUNCE_TIMER = null;

  document.addEventListener('DOMContentLoaded', function () {
    var itemsEl    = document.querySelector('.ri-cart-page__items');
    var subtotalEl = document.getElementById('ri-cart-page-subtotal');
    var progressEl = document.getElementById('ri-cart-page-progress');
    var progressWrap = document.querySelector('.ri-cart-page__progress');

    if (!itemsEl) return;

    /* ── Delegated qty / remove clicks ── */
    itemsEl.addEventListener('click', function (e) {
      // Qty buttons
      var qtyBtn = e.target.closest('.ri-qty-btn');
      if (qtyBtn) {
        var key     = qtyBtn.dataset.key;
        var action  = qtyBtn.dataset.action;
        var numEl   = qtyBtn.parentElement.querySelector('.ri-cart-page-item__qty-num');
        var current = numEl ? parseInt(numEl.textContent, 10) : 1;
        var newQty  = action === 'plus' ? current + 1 : Math.max(0, current - 1);
        changeItem(key, newQty);
        return;
      }

      // Remove button
      var removeBtn = e.target.closest('.ri-cart-page-item__remove');
      if (removeBtn) {
        changeItem(removeBtn.dataset.key, 0);
      }
    });

    /* ── Debounced order note ── */
    var noteEl = document.querySelector('.ri-cart-page__note');
    if (noteEl) {
      noteEl.addEventListener('input', function () {
        clearTimeout(NOTE_DEBOUNCE_TIMER);
        var note = noteEl.value;
        NOTE_DEBOUNCE_TIMER = setTimeout(function () {
          postJSON('/cart/update.js', { note: note });
        }, 600);
      });
    }

    /* ── Cart mutation ── */
    function changeItem(key, quantity) {
      setLoading(true);
      postJSON('/cart/change.js', { id: key, quantity: quantity })
        .then(function (cart) {
          if (quantity === 0) {
            // Check if the item was the last one
            if (cart.item_count === 0) {
              location.reload();
              return;
            }
            // Remove the item row from the DOM
            var row = document.querySelector('.ri-cart-page-item[data-key="' + key + '"]');
            if (row) row.remove();
            // Also remove from summary
            var summaryLine = document.querySelector('.ri-cart-page__summary-line[data-summary-key="' + key + '"]');
            if (summaryLine) summaryLine.remove();
          }
          updateSummary(cart);
          setLoading(false);
        })
        .catch(function () { setLoading(false); });
    }

    /* ── Update summary from cart JSON ── */
    function updateSummary(cart) {
      // Subtotal
      if (subtotalEl) subtotalEl.textContent = formatMoneyText(cart.total_price);

      // Update [data-cart-count] in header
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });

      // Update per-item qty and line prices in summary + item rows
      cart.items.forEach(function (item) {
        // Qty display in item row
        var qtyNumEl = document.querySelector(
          '.ri-cart-page-item[data-key="' + item.key + '"] .ri-cart-page-item__qty-num'
        );
        if (qtyNumEl) qtyNumEl.textContent = item.quantity;

        // Line total in item row
        var totalEl = document.querySelector(
          '.ri-cart-page-item[data-key="' + item.key + '"] .ri-cart-page-item__total'
        );
        if (totalEl) {
          var hasSale = item.original_line_price !== item.final_line_price;
          if (hasSale) {
            totalEl.innerHTML =
              '<s class="ri-cart-page-item__total--compare">' + formatMoney(item.original_line_price) + '</s>' +
              '<span class="ri-cart-page-item__total--sale">' + formatMoney(item.final_line_price) + '</span>';
          } else {
            totalEl.textContent = formatMoneyText(item.final_line_price);
          }
        }

        // Summary sidebar line price
        var summaryPriceEl = document.querySelector(
          '.ri-cart-page__summary-line[data-summary-key="' + item.key + '"] .ri-cart-page__summary-line-price'
        );
        if (summaryPriceEl) summaryPriceEl.textContent = formatMoneyText(item.final_line_price);

        // Summary sidebar qty
        var summaryQtyEl = document.querySelector(
          '.ri-cart-page__summary-line[data-summary-key="' + item.key + '"] .ri-cart-page__summary-line-qty'
        );
        if (summaryQtyEl) summaryQtyEl.textContent = '× ' + item.quantity;
      });

      // Progress bar
      if (progressEl && progressWrap) {
        var threshold = parseInt(progressWrap.dataset.threshold || '0', 10);
        if (threshold > 0) {
          var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
          progressEl.style.width = pct + '%';
          var msgEl = progressWrap.querySelector('.ri-cart-page__progress-msg');
          if (msgEl) {
            if (cart.total_price >= threshold) {
              msgEl.textContent = '✦ Free shipping unlocked!';
              msgEl.classList.add('ri-cart-page__progress-msg--done');
            } else {
              msgEl.textContent = formatMoneyText(threshold - cart.total_price) + ' away from free shipping';
              msgEl.classList.remove('ri-cart-page__progress-msg--done');
            }
          }
        }
      }
    }

    /* ── Helpers ── */
    function setLoading(on) {
      var layout = document.querySelector('.ri-cart-page__layout');
      if (layout) layout.style.opacity = on ? '0.6' : '';
    }

    function postJSON(url, data) {
      return fetch(url, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify(data)
      }).then(function (r) {
        if (!r.ok) throw new Error('cart_error');
        return r.json();
      });
    }

    /* Prices are written both into innerHTML strings and into textContent here,
       and shop.money_format carries markup (<span class=money>…</span>) — so the
       two need different treatment. The old single helper also omitted thousands
       separators entirely, printing "Rs. 1449900.00" beside server-rendered
       "Rs1,449,900.00". */
    function formatMoney(cents) {
      return window.RIMoney.format(cents);
    }

    function formatMoneyText(cents) {
      return window.RIMoney.text(cents);
    }
  });

})();
